import { UpdateEmployeeAccountDetails, UpdateEmployeeAccountDetailsVariables } from "_graphql/mutation/__generated__/UpdateEmployeeAccountDetails";

import { EmployeeForm } from "components/forms";
import { LocationGenerics } from "router/location";
import { Modal } from "components";
import _ from "lodash";
import { employeeValidationSchema } from "./create";
import { getDomain } from "router/filter";
import toast from "react-hot-toast";
import { updateEmployee } from "_graphql/visal/mutations/employee";
import { useEffect } from "react";
import { useFormik } from "formik";
import { useKEKEmployee } from "hooks/data/use-employees";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";
import { wrapClick } from "utils";

export default function UpdateEmployeeContainer({
    open,
    setOpen,
    refetch,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
    refetch?: () => void;
}) {
    const searchParams = useSearch<LocationGenerics>();
    const [update, { loading }] = useMutation<UpdateEmployeeAccountDetails, UpdateEmployeeAccountDetailsVariables>(updateEmployee, {
        refetchQueries: ["Employees"]
    });
    const { employee, loading: fetching } = useKEKEmployee({ employeeId: searchParams?.id || "" });
    const domain = getDomain();
    const form = useFormik<any>({
        initialValues: {
            employee_email: "",
            employee_first_name: "",
            employee_last_name: "",
            employee_phonenumber: "",
            employee_position: "",
            user_role_id: "",
        },
        validationSchema: employeeValidationSchema,
        onSubmit: async (variables) => {
            await update({
                variables: {
                    employee: _.omitBy({
                        ..._.omit(variables, ["domain"]),
                        employee_position: domain === "Visal" ? variables.employee_position : variables.user_role_id?.position,
                        user_role_id: domain === "KEK" ? variables.user_role_id?.user_role_id : undefined,
                    }, _.isUndefined) as any,
                    employeeId: searchParams?.id || "",
                },
            }).then(({ data }) => {
                if (data?.updateEmployeeAccountDetails) {
                    toast.success("Employee updated successfully");
                    refetch?.();
                    form.resetForm();
                } else {
                    toast.error("Failed to update employee");
                }
            });
        },
        onReset: () => {
            setOpen(false);
        },
    });

    useEffect(() => {
        if (employee) {
            form.setValues({
                employee_email: employee?.employee_email,
                employee_first_name: employee?.employee_first_name,
                employee_last_name: employee?.employee_last_name,
                employee_phonenumber: employee?.employee_phonenumber,
                employee_position: employee?.user?.user_role?.position || "",
                user_role_id: employee?.user?.user_role?.user_role_id || "",
            })
        }
    }, [employee]);

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            loading={fetching}
            title="Update  Employee"
            description="Provide the details to update employee"
            renderActions={() => (
                <>
                    <button
                        type="button"
                        disabled={loading}
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={wrapClick(form.handleSubmit)}
                    >
                        {loading ? "Updating Employee..." : "Update Employee"}
                    </button>
                </>
            )}
        >
            <EmployeeForm form={form} />
        </Modal>
    );
}
